import { useState } from 'react';
import CardCustomization from '../../components/CardCustomization/CardCustomization';

import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import PageHeader from '../../components/PageHeader';
import './CardEdit.scss';

const MockCardData = {
	label: 'Test label',
	color: 'purple',
	Name: 'Volodymyr Koz',
	number: '5457325733771221',
};

const CardEdit = () => {
	const [color, setColor] = useState(MockCardData.color);
	const [label, setLabel] = useState(MockCardData.label);
	const [loading, setLoading] = useState(false);
	const initialStates = {
		color: MockCardData.color,
		label: MockCardData.label,
	};

	const isChanged = color !== initialStates.color || label !== initialStates.label;

	const navigate = useNavigate();

	// const editCard = async () => {
	// 	try {
	// 		setLoading(true);
	// 		const res = await RequestService.EditCard({
	// 			Color: color,
	// 			Label: label,
	// 		});
	// 		setLoading(false);
	// 		if (res.Status === 'Success') {
	// 			navigate(-1);
	// 		}
	// 	} catch (e) {
	// 		console.error(e);
	// 	}
	// };

	return (
		<div className='CardEdit'>
			<PageHeader header='Design card' collapsed={true} />
			<div className='CardEdit__body'>
				<CardCustomization
					selectedColor={color}
					label={label}
					onColorChange={setColor}
					onLabelChange={setLabel}
					cardholderName={MockCardData.Name}
					cardNumber={MockCardData.number}
				/>

				<Button loading={loading} disabled={!isChanged} className='CardEdit__button'>
					Save
				</Button>
			</div>
		</div>
	);
};

export default CardEdit;
